import { render, staticRenderFns } from "./downloader-tips.vue?vue&type=template&id=d3376f20&scoped=true"
import script from "./downloader-tips.vue?vue&type=script&lang=js"
export * from "./downloader-tips.vue?vue&type=script&lang=js"
import style0 from "./downloader-tips.vue?vue&type=style&index=0&id=d3376f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3376f20",
  null
  
)

export default component.exports